import React from 'react';
import ReactDOM from 'react-dom';
import Backbone from 'backbone';
import { TooltipHost } from '@bingads-webui-react/fabric-control';
import { Glyphicon } from '@bingads-webui-react/primitive-unthemed';
import { DeterministicViewForBackBoneView } from '@bingads-webui/deterministic-wrapper-view';

// eslint-disable-next-line react/prop-types
export const MetricToolTip = ({ content }) => (
  <TooltipHost
    content={content}
  >
    <Glyphicon glyph="ba-Info" className="metric-info" />
  </TooltipHost>
);

export class MetricToolTipBackBoneView extends Backbone.View {
  initialize({ content }) {
    this.content = content;
  }

  render() {
    ReactDOM.render(
      (<MetricToolTip content={this.content} />),
      this.el
    );
    return this;
  }

  remove() {
    ReactDOM.unmountComponentAtNode(this.el);
    return super.remove();
  }
}

export function getDeterministicTooltipView(content) {
  return new DeterministicViewForBackBoneView({
    view: new MetricToolTipBackBoneView({ content }),
  });
}
